/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Formik, Form, Field } from "formik";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField as TextFieldMUI,
  Grid,
  FormControlLabel,
  Typography,
  CircularProgress,
  FormHelperText,
} from "@mui/material";
import {
  TextField,
  Switch as SwitchFormik,
  fieldToTextField,
} from "formik-mui";
import { useSelector, useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import Autocomplete from "@mui/lab/Autocomplete";

import { getUsers } from "../../../../store/ducks/duckUsers";
import useDebounce from "../../../../hooks/useDebounce";
import { useUser } from "../../../../auth/UserProvider";
import {
  addGroup,
  editGroup,
  getGroups,
} from "../../../../store/ducks/duckGroups";
import { BorderLinearProgress } from "../../../../components/LoadingComponent";

const FormikAutocomplete = ({ textFieldProps, ...props }) => {
  const [loading, setLoading] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const dispatch = useDispatch();
  const debouncedSearchTerm = useDebounce(searchInput, 500);

  const {
    // eslint-disable-next-line react/prop-types
    form: { setTouched, setFieldValue },
  } = props;
  const { error, helperText, ...field } = fieldToTextField(props);
  const { name } = field;

  useEffect(
    () => {
      if (debouncedSearchTerm) {
        if(!hasSpaces(searchInput)){
          setLoading(true);
          // Fire off our API call
          dispatch(getUsers(searchInput)).then((_) => setLoading(false));
        }else{
          const arrayStrings = splitString(searchInput);

          setLoading(true);
          // Fire off our API call
          dispatch(getUsers(arrayStrings[0])).then((_) => setLoading(false));
        }
        
      }
    },

    // eslint-disable-next-line react-hooks/exhaustive-deps
    [debouncedSearchTerm]
  );

  const hasSpaces = (searchInput) => {
    if(searchInput.indexOf(' ') >= 0){
      return true;
    }else{
      return false;
    }
  } 

  const splitString = (searchInput) =>{

    const splitString = searchInput.split(" ");

    return splitString;
  }
  

  return (
    <Autocomplete
      {...props}
      {...field}
      getOptionLabel={({ firstName, lastName, networkUser }) => {
        return ` ${networkUser} ${firstName} ${lastName}`;
      }}
      loading={loading}
      renderInput={(props) => (
        <TextFieldMUI
          {...props}
          {...textFieldProps}
          InputProps={{
            // eslint-disable-next-line react/prop-types
            ...props.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}

                {/* eslint-disable-next-line react/prop-types */}
                {props.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
          error={error}
          helperText={helperText}
        />
      )}
      renderOption={({ firstName, lastName, networkUser }, _state) => (
        <Typography>
          {networkUser}{" "}
          <Typography color="textSecondary">{`${firstName} ${lastName}`}</Typography>
        </Typography>
      )}
      onBlur={() => setTouched({ [name]: true })}
      onChange={(_, value) => setFieldValue(name, value)}
      onInputChange={(event, newInputValue) => {
        event.preventDefault();
        setSearchInput(newInputValue);
      }}
    />
  );
};

const GroupForm = (props) => {
  const { initialValues, isEdit, handleClose, open } = props;

  const groupsName = useSelector((state) =>
    state.groups.data.map((g) => g.name)
  );

  const { isAdmin } = useUser();
  const users = useSelector((state) => state.users.data);

  const { enqueueSnackbar } = useSnackbar();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getGroups());
  }, [dispatch]);

  return (
    <>
      <Formik
        initialValues={initialValues}
        validate={({ id, name }) => {
          let errors = {};

          if (!name) {
            errors.name = "Required";
          }
          if (id === 0 && groupsName.includes(name)) {
            errors.name = `The name must be unique`;
          }

          return errors;
        }}
        onSubmit={(values, { setSubmitting }) => {
          return values.id > 0
            ? dispatch(editGroup(values, () => setSubmitting(false))).then(
                () => {
                  handleClose();
                  enqueueSnackbar(
                    `Edited '${values.name}' group Successfully`,
                    {
                      variant: "success",
                    }
                  );
                }
              )
            : dispatch(addGroup(values, () => setSubmitting(false))).then(
                () => {
                  handleClose();
                  enqueueSnackbar(`Added '${values.name}' group Successfully`, {
                    variant: "success",
                  });
                }
              );
        }}
      >
        {({ submitForm, isSubmitting, values }) => (
          <Form>
            <Dialog
              fullWidth
              aria-labelledby="form-dialog-title"
              maxWidth="xs"
              open={open}
              onClose={handleClose}
            >
              {isSubmitting && <BorderLinearProgress />}
              <DialogTitle id="form-dialog-title">
                {isEdit && initialValues?.id !== 0
                  ? "Edit"
                  : isEdit && initialValues?.id === 0
                  ? "Add"
                  : null}
                {initialValues.deleted && isAdmin && (
                  <>
                    <FormControlLabel
                      control={
                        <Field
                          color="primary"
                          component={SwitchFormik}
                          name="deleted"
                          type="checkbox"
                        />
                      }
                      label="Deleted"
                      labelPlacement="end"
                      style={{ marginRight: 0, marginLeft: "60%" }}
                    />
                    <FormHelperText
                      style={{
                        marginRight: "5%",
                        textAlign: "right",
                      }}
                    >
                      {values?.deleted ? "Enable" : "Disable"}
                    </FormHelperText>
                  </>
                )}
              </DialogTitle>
              <DialogContent style={{ overflow: "hidden" }}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Grid container spacing={1}>
                      <Grid item xs={6}>
                        <Field
                          component={TextField}
                          label="Name"
                          margin="dense"
                          name="name"
                          type="text"
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <FormControlLabel
                          control={
                            <Field
                              color="primary"
                              component={SwitchFormik}
                              name="isEconomics"
                              type="checkbox"
                            />
                          }
                          label="Economics"
                          labelPlacement="end"
                          style={{
                            padding: "9px ​6px 5px 34px",
                            marginLeft: 0,
                          }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <Field
                          multiple
                          component={FormikAutocomplete}
                          disabled={values.deleted}
                          margin="dense"
                          name="owners"
                          options={users}
                          style={{ width: "100%", height: "100%" }}
                          textFieldProps={{
                            fullWidth: true,
                            margin: "dense",
                            variant: "outlined",
                            label: "Owners",
                          }}
                          variant="outlined"
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid item xs={12}>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <Field
                          fullWidth
                          multiple
                          component={TextField}
                          label="Description"
                          margin="dense"
                          name="description"
                          type="text"
                          variant="outlined"
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={handleClose}
                >
                  Close
                </Button>
                {isEdit && (
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={submitForm}
                  >
                    Save
                  </Button>
                )}
              </DialogActions>
            </Dialog>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default GroupForm;
